import { LoadingIcon } from '../../../LoadingIcon';

interface DashboardDetailsSubmitButtonProps {
  formId: string;
  isSubmitting: boolean;
  isValidatingWallet: boolean;
  isFormValid: boolean;
  hasChanges: boolean;
}

export function DashboardDetailsSubmitButton({
  formId,
  isSubmitting,
  isValidatingWallet,
  isFormValid,
  hasChanges,
}: DashboardDetailsSubmitButtonProps) {
  const isDisabled = isSubmitting || !isFormValid || !hasChanges;

  return (
    <button
      type="submit"
      form={formId}
      disabled={isDisabled}
      className={`relative bg-teal-600 text-white font-medium px-6 py-2 rounded-lg transition-all duration-300 min-w-[120px] ${
        isDisabled ? 'opacity-50' : 'hover:bg-teal-700'
      }`}
      style={{
        cursor: isDisabled ? 'default' : 'pointer',
      }}
    >
      <span
        className={`inline-flex items-center justify-center transition-opacity duration-300 ${
          isSubmitting ? 'opacity-0' : 'opacity-100'
        }`}
      >
        {isValidatingWallet ? 'Validating...' : 'Update'}
      </span>
      {isSubmitting && (
        <div className="absolute inset-0 flex items-center justify-center">
          <LoadingIcon
            label="Submitting"
            className="size-5 text-white transition-opacity duration-300"
          />
        </div>
      )}
    </button>
  );
}
